<template>
  <v-row>
    <v-col md="4" cols="12">
      <chart-container
        style="height: 100%"
        :loading="isLoading"
        :no-data="isEmptyProportion(proportionByOrdersStatuses)"
      >
        <template #chart>
          <proportion-chart
            title="Принятые - Отмены"
            :items="proportionByOrdersStatuses"
            :colors="['#FF9100', '#EA306B']"
            legend-container-id="proportion-by-orders-statuses"
          />
        </template>
      </chart-container>
    </v-col>
    <v-col md="4" cols="12">
      <chart-container
        style="height: 100%"
        :loading="isLoading"
        :no-data="isEmptyProportion(proportionByOrdersSVP)"
      >
        <template #chart>
          <proportion-chart
            title="Среднее время подтверждения"
            :items="proportionByOrdersSVP"
            :colors="['#4DAF4A', '#FF9D00', '#EA306B']"
            legend-container-id="proportion-by-orders-svp"
          />
        </template>
      </chart-container>
    </v-col>
    <v-col md="4" cols="12">
      <chart-container
        style="height: 100%"
        :loading="isLoading"
        :no-data="isEmptyProportion(proportionByOrdersSources)"
      >
        <template #chart>
          <proportion-chart
            title="Источники обработанных заказов"
            :items="proportionByOrdersSources"
            :colors="['#FF9100', '#EA306B']"
            legend-container-id="proportion-by-orders-sources"
          />
        </template>
      </chart-container>
    </v-col>
  </v-row>
</template>

<script>
  import ProportionChart from '@/components/stat/revenue/ProportionChart.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import ordersApi from '@/api/statistics/call-center/orders'
  import { formatNumberToThousandths } from '@/util/num-format'
  import ChartContainer from '@/components/stat/ChartContainer.vue'

  export default {
    name: 'ProportionChartsView',
    components: {
      ChartContainer,
      ProportionChart,
    },
    mixins: [snackbarMessage],
    data () {
      return {
        isLoading: false,
        proportionByOrdersStatuses: [],
        proportionByOrdersSVP: [],
        proportionByOrdersSources: [],
      }
    },
    methods: {
      isEmptyProportion (arr) {
        return arr.every((item) => !item.percent)
      },
      fetchStatistics (data) {
        this.isLoading = true

        Promise.all([
          ordersApi.fetchProportionByOrderStatuses(data),
          ordersApi.fetchProportionByOrderSVP(data),
          ordersApi.fetchProportionByOrderSources(data),
        ])
          .then((responses) => {
            this.proportionByOrdersStatuses = this.prepareProportionData(
              responses[0].items,
            )
            this.proportionByOrdersSVP = this.prepareProportionData(
              responses[1].items,
            )
            this.proportionByOrdersSources = this.prepareProportionData(
              responses[2].items,
            )
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.isLoading = false
          })
      },
      prepareProportionData (items) {
        return items.map((item) => {
          if (item.value) {
            item.formattedValue = `${formatNumberToThousandths(item.value)} шт`
          }

          return item
        })
      },
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/styles/statistic.less';
</style>
